export const supportedLngs = ["it", "en"];
export const fallbackLng = "it";

export default {
  supportedLngs,
  fallbackLng,
  defaultNS: "common",
  react: { useSuspense: false },
};
